import React from 'react';
import { FaPhoneSquareAlt, FaFileSignature } from "react-icons/fa"; 
import { useDispatch, useSelector } from 'react-redux';
import { settingSliceAction } from '../../store/settingSlice';

const SettingMenu = () => {
    const dispatch = useDispatch()
    const selectedMenu = useSelector((state:any)=>{return state.settingSlice.selectedMenu})

    const customViewsIframe = document.querySelector('#customviews-container')!;
    customViewsIframe.setAttribute('style', "height: 0; width: 0;");
    
    const onMenuSelected = (selectedMenu:string) => {
        dispatch(settingSliceAction.setSelectedMenu(selectedMenu))
    }
    return (
        <React.Fragment>
            <div className="card wrapup-box collapse show mt-3" id="ChatWrapup">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className='m-0'>Settings</h6>
                </div>
                <div className="card-body min-height-400">
                    <ul className='mailbox-list list-unstyled'>
                        <li><button onClick={()=>{ onMenuSelected("Call") }} className={`${(selectedMenu === 'Call') ? `active-mailbox` : ``}`}><FaPhoneSquareAlt /> Calls </button></li> 
                        <li><button onClick={()=>{ onMenuSelected("EmailSignature") }} className={`${(selectedMenu === 'EmailSignature') ? `active-mailbox` : ``}`}><FaFileSignature /> Email Signature </button></li>
                    </ul>
                </div>
            </div>
        </React.Fragment>
    )
}
export default SettingMenu;